import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash';
import { fieldData } from '../src/fieldData';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from '@/composables/useI18n';
import VueI18n from 'vue-i18n';

interface IField {
    key: string;
    type: string;
    desc?: string;
    mainTip?: string;
    fullTip?: string;
}

interface ISearchField {
    id: string;
    label: VueI18n.TranslateResult;
    nav: string;
    fields: IField[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldView',
  props: {
    currentNav: null
  },
  emits: ["update-nav-handler"],
  setup(__props: any, { emit }: { emit: ({(e: 'update-nav-handler', value: ISearchField[]): void,
}), expose: any, slots: any, attrs: any }) {

const deleteSearchFields = ['TTL_JPTRANS', 'ABST_JPTRANS', 'CLMS_JPTRANS', 'DESC_JPTRANS'];

const { get, filter, includes, map } = _;

const { locale, t } = useI18n();





const serviceArea = get(window, 'zPREFACE.accountInfo.site_region', 'CN');

const searchFields = ref<ISearchField[]>([]);

const searchFieldList = computed(() => {
    if (serviceArea === 'CN' && searchFields.value[0]) {
        var after = filter(searchFields.value[0].fields, item => !includes(deleteSearchFields, item.key));
        searchFields.value[0].fields = after; //eslint-disable-line
    }
    return searchFields.value;
});

onMounted(async () => {
    const { searchHelperFieldData } = await import('library-@/AdvancedSearchForm/constants/fieldDataMap');
    const data = map(fieldData, item => {
        const fields = map(item.fields, subItem => {
            const desc = get(searchHelperFieldData, `${subItem.key}.desc.${locale}`);
            const mainTip = `${subItem.key === 'CCF_' ? 'CCF_PR' : subItem.key}:${get(searchHelperFieldData, `${subItem.key}.mainTip.${locale}`)}`;
            const fullTip = get(searchHelperFieldData, `${subItem.key}.fullTip.${locale}`);
            subItem = {
                ...subItem,
                desc,
                mainTip,
                fullTip,
            };
            return subItem;
        });
        return {
            fields,
            id: item.id,
            nav: `#${item.id}`,
            label: t(`searchHelper['title_${item.type}']`),
        };
    });
    searchFields.value = data;
    emit('update-nav-handler', searchFields.value);
});

return { __sfc: true,deleteSearchFields, get, filter, includes, map, locale, t, emit, serviceArea, searchFields, searchFieldList, _, fieldData, computed, onMounted, ref, useI18n, VueI18n }
}

})